export default __webpack_public_path__ + "static/media/Elements.bfb33bde.svg";